import request from '@/util/request';
import qs from 'qs';

export const getPage = (params, options) =>
request.get('/api/v4ward/fee-item-tax/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/fee-item-tax/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/fee-item-tax/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/fee-item-tax/save', params, options)

export const update = (params, options) =>
request.post('/api/v4ward/fee-item-tax/update', params, options)

//获取种类细分
export const getSortTypeList = (params, options) =>
  request.get('/api/v4ward/fee-item-tax/sort-type-list', Object.assign({}, options, { params }))
//获取支付方式
export const getPayTypeList = (params, options) =>
  request.get('/api/propertyCharges/pay/paylist', Object.assign({}, options, { params }))
//操作日志
export const getOperateLogPage = (params, options) =>
  request.get('/api/v4ward/fee-item-tax-log/page', Object.assign({}, options, { params }));

//获取小区列表
export const getCommunityList = (params, options) =>
  request.get('/api/v4ward/fee-item-tax/get-community-list', Object.assign({}, options, { params }));

//获取税收收费费项列表
export const getList = (params, options) =>
  request.get('/api/v4ward/fee-item-tax/list', Object.assign({}, options, { params }));
